import { SITE, MANIFESTO_INTRO } from "../../lib/content";
import { MaskLine, FadeUp, SectionLabel } from "./Reveal";

const STATS = [
  { n: "9–12", l: "Classes covered" },
  { n: "3", l: "Core subjects" },
  { n: "1:8", l: "Batch ratio" },
  { n: "100%", l: "Concept focus" },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-paper py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <SectionLabel>About the Academy</SectionLabel>
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <h2 className="font-heading font-extrabold tracking-tight text-ink text-3xl sm:text-5xl lg:text-6xl leading-[1.02]">
              <MaskLine>Where concepts</MaskLine>
              <MaskLine delay={0.1}>
                become <span className="text-flame">confidence.</span>
              </MaskLine>
            </h2>
          </div>
          <div className="lg:col-span-4">
            <FadeUp delay={0.15}>
              <p className="text-ink/70 text-lg leading-relaxed">{MANIFESTO_INTRO}</p>
              <p className="mt-4 text-ink/50 text-sm">
                {SITE.name} — coaching in the heart of Hajo, Kamrup, built around every
                student&apos;s pace and potential.
              </p>
            </FadeUp>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 border-t border-l border-ink/10">
          {STATS.map((s, i) => (
            <FadeUp key={s.l} delay={i * 0.08}>
              <div className="border-r border-b border-ink/10 p-8">
                <div className="font-heading font-black text-4xl lg:text-5xl text-ink tracking-tighter">
                  {s.n}
                </div>
                <div className="mt-2 text-xs uppercase tracking-[0.2em] text-ink/50">{s.l}</div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
